import { render } from "./CreateFamilyGroupView.vue?vue&type=template&id=6e9b0bf4&scoped=true"
import script from "./CreateFamilyGroupView.vue?vue&type=script&lang=js"
export * from "./CreateFamilyGroupView.vue?vue&type=script&lang=js"

import "./CreateFamilyGroupView.vue?vue&type=style&index=0&id=6e9b0bf4&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9b0bf4"]])

export default __exports__